import { Form } from 'antd/lib'
import { useEffect } from 'react'
import { ClassLevelAttributesListProps } from 'Types/Classes.types'
import { AttributeValueType } from 'Types/Attribute.types'
import { ClassLevelAttributesPanel } from 'Components/tasks/Classes/ClassLevelAttributesPanel'

export const ClassLevelAttributesListItem = (
    props: ClassLevelAttributesListProps & { annotationId: string }
) => {
    const [form] = Form.useForm()
    const { setForm, annotationId } = props

    const attributes = props.getAttributesForAnnotation(annotationId)
    const taskClass = props.getClassForAnnotation(annotationId)
    const textPreview = props.getTextPreview(annotationId)
    const values = props.getValuesForAnnotation(annotationId)

    useEffect(() => {
        setForm(annotationId, form)
    }, [form, annotationId, setForm])

    useEffect(() => {
        if (!values) return
        const formValues = {} as Record<string, AttributeValueType>
        attributes.forEach(curr => {
            formValues[curr.name] = values[curr.name]?.data?.value
        })
        form.setFieldsValue(formValues)
    }, [form, attributes, values])

    if (!taskClass || !attributes.length) return null

    return (
        <ClassLevelAttributesPanel
            annotationId={annotationId}
            classColor={taskClass.color}
            classLabel={taskClass.label}
            textPreview={textPreview}
            attributes={attributes}
            values={values}
            onUpdateAttribute={(attrName, value) =>
                props.onUpdateAttribute(annotationId, attrName, value)
            }
            onHoverAnnotation={props.onHoverAnnotation}
            isReadOnly={props.isReadOnly}
            form={form}
            attributesOnUI={props.attributesOnUI}
            isIncomplete={props.isAnnotationIncomplete(annotationId)}
            highlightIncomplete={props.getHighlightIncomplete()}
        />
    )
}
